import { useEffect, useState } from "react";
import { useLocation } from "wouter";
import { ProductGallery } from "@/components/product-gallery";
import { TruckSelectionModal } from "@/components/truck-selection-modal";
import { SplashWelcomeModal } from "@/components/splash-welcome-modal";
import { useAuth } from "@/hooks/useAuth";

const WELCOME_SEEN_KEY = "openbox:welcomeSeen";

export default function Home() {
  const { isLoading, user } = useAuth();
  const [showWelcomeModal, setShowWelcomeModal] = useState(false);

  useEffect(() => {
    document.title = "OpenBox by ShopJimmy";
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, []);

  useEffect(() => {
    if (isLoading) return;
    
    // Check for ?showWelcome=true query param to force modal display for testing
    const urlParams = new URLSearchParams(window.location.search);
    const forceShow = urlParams.get('showWelcome') === 'true';
    
    if (forceShow) {
      setShowWelcomeModal(true);
      return;
    }
    
    if (!user) {
      const hasSeenWelcome = localStorage.getItem(WELCOME_SEEN_KEY);
      if (!hasSeenWelcome) {
        setShowWelcomeModal(true);
      }
    }
  }, [isLoading, user]);

  const handleCloseWelcome = () => {
    localStorage.setItem(WELCOME_SEEN_KEY, "true");
    setShowWelcomeModal(false);
  };

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <p className="text-muted-foreground">Loading...</p>
      </div>
    );
  }

  return (
    <div>
      <SplashWelcomeModal open={showWelcomeModal} onClose={handleCloseWelcome} />
      <TruckSelectionModal />
      <ProductGallery />
    </div>
  );
}
